import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import {
  listTalentVideos,
  getPlaybackUrl,
  type ListVideosParams,
  type PlaybackUrlParams,
} from './talentVideosApi';

export const TALENT_VIDEOS_QUERY_KEY = ['talent', 'videos'] as const;
export const VIDEO_PLAYBACK_URL_QUERY_KEY = ['talent', 'video', 'url'] as const;

export function useTalentVideos(params: ListVideosParams) {
  return useQuery({
    queryKey: [...TALENT_VIDEOS_QUERY_KEY, params.shortlistPublicKey, params.talentPublicKey],
    queryFn: () => listTalentVideos(params),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}

/**
 * Pide la signed URL del video. `enabled` permite que el caller dispare la query
 * solo cuando el user clickea play (no on-mount). El refetch automático cuando el
 * URL está cerca de expirar lo maneja el componente VideoPlayer con un setTimeout.
 */
export function useVideoPlaybackUrl(params: PlaybackUrlParams, enabled: boolean) {
  return useQuery({
    queryKey: [
      ...VIDEO_PLAYBACK_URL_QUERY_KEY,
      params.shortlistPublicKey,
      params.talentPublicKey,
      params.videoPublicKey,
    ],
    queryFn: () => getPlaybackUrl(params),
    enabled,
    // staleTime corto: el URL caduca en 30 min — re-pedirlo dentro de ese window es OK.
    staleTime: 0,
    // gcTime también corto para no retener URLs viejos en cache.
    gcTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 1;
    },
  });
}
